/**************************************************
 * Nombre:       Formulario_Respuestas_Test
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ChatOutlined, CheckOutlined, FlagOutlined} from "@mui/icons-material";
import IngresoSelectFalsoVerdadero from "../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";

const Formulario_Respuestas_Test = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Pregunta'} dato={'pregunta'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={CheckOutlined} nombre={'Respuesta correcta'} dato={'correcta'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={ChatOutlined} nombre={'Respuesta escogida'} dato={'respuesta'} {...props}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectFalsoVerdadero Icono={FlagOutlined} nombre={'Dar punto'} dato={'punto'} {...props}
                                                 />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Respuestas_Test